const CompliancePermissions = {
  edit: 'compliance:edit',
  create: 'compliance:create',
  delete: 'compliance:delete',
  view: 'compliance:view',
}

export default CompliancePermissions
